import dayjs from 'dayjs'

import { env } from 'src/env/client.mjs'
import { Certification } from 'src/server/router/certifications/types'
import { CertificationType } from 'src/types/certification'

const nextPublicAssetsDomain = env.NEXT_PUBLIC_ASSETS_DOMAIN

const NAMES = {
  [CertificationType.Kowhai]: '10,000 native trees',
  [CertificationType.Hiriwa]: '2,000 native trees',
  [CertificationType.Kahurangi]: '500 native trees'
}

const BASE_DESC = {
  [CertificationType.Kowhai]:
    'Download your Committed to Climate mark for funding at least 10,000 native trees in',
  [CertificationType.Hiriwa]:
    'Download your Committed to Climate mark for funding at least 2,000 native trees in',
  [CertificationType.Kahurangi]:
    'Download your Committed to Climate mark for funding at least 500 native trees in'
}

const UNEARNED_DESC = {
  [CertificationType.Kowhai]:
    'Unlock this mark by funding at least 10,000 native trees in',
  [CertificationType.Hiriwa]:
    'Unlock this mark by funding at least 2,000 native trees in',
  [CertificationType.Kahurangi]:
    'Unlock this mark by funding at least 500 native trees in'
}

const BASE_DOWNLOAD_URL = {
  [CertificationType.Kowhai]: `assets/toolkit/TreesThatCount_Kowhai_Committed_to_Climate_Certificates_`,
  [CertificationType.Hiriwa]: `assets/toolkit/TreesThatCount_Hiriwa_Committed_to_Climate_Certificates_`,
  [CertificationType.Kahurangi]: `assets/toolkit/TreesThatCount_Kahurangi_Committed_to_Climate_Certificates_`
}

export const listCertifications = (
  funderStats: { SeasonName: string; TreesFunded: number }[]
) => {
  const certifications: Certification[] = []

  const earliestYear = dayjs().add(-3, 'years').year()

  funderStats
    .filter(
      stats =>
        stats.SeasonName !== 'All' && Number(stats.SeasonName) >= earliestYear
    )
    .sort((a, b) => {
      const seasonNameA = a.SeasonName
      const seasonNameB = b.SeasonName
      if (seasonNameA > seasonNameB) {
        return -1
      }
      if (seasonNameA < seasonNameB) {
        return 1
      }

      // names must be equal
      return 0
    })
    .forEach(stats => {
      let certificationAwarded: CertificationType | null
      let nextCertification: CertificationType | null

      if (stats.TreesFunded < 500) {
        certificationAwarded = null
        nextCertification = CertificationType.Kahurangi
      } else if (stats.TreesFunded >= 10_000) {
        certificationAwarded = CertificationType.Kowhai
        nextCertification = null
      } else if (stats.TreesFunded >= 2000 && stats.TreesFunded < 10_000) {
        certificationAwarded = CertificationType.Hiriwa
        nextCertification = CertificationType.Kowhai
      } else {
        certificationAwarded = CertificationType.Kahurangi
        nextCertification = CertificationType.Hiriwa
      }

      if (certificationAwarded !== null) {
        certifications.push({
          Name: NAMES[certificationAwarded],
          Description: `${BASE_DESC[certificationAwarded]} ${stats.SeasonName}`,
          Image: `${nextPublicAssetsDomain}/assets/img/images/funding/mark_${CertificationType[
            certificationAwarded
          ]?.toLowerCase()}_${stats.SeasonName}.svg`,
          CertificateType: certificationAwarded,
          SeasonName: stats.SeasonName,
          DownloadFilePath: `${nextPublicAssetsDomain}/${BASE_DOWNLOAD_URL[certificationAwarded]}${stats.SeasonName}.zip`,
          Awarded: true
        })
      }

      if (nextCertification !== null) {
        certifications.push({
          Name: NAMES[nextCertification],
          Description: `${UNEARNED_DESC[nextCertification]} ${stats.SeasonName}`,
          Image: `${nextPublicAssetsDomain}/assets/img/images/funding/mark_${CertificationType[
            nextCertification
          ]?.toLowerCase()}_${stats.SeasonName}_unearned.svg`,
          CertificateType: nextCertification,
          SeasonName: stats.SeasonName,
          DownloadFilePath: '',
          Awarded: false
        })
      }
    })

  return certifications
}
